import { render, staticRenderFns } from "./IndustryTrendsChildEn.vue?vue&type=template&id=8e0d0f50&"
import script from "./IndustryTrendsChildEn.vue?vue&type=script&lang=js&"
export * from "./IndustryTrendsChildEn.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTrendsChildEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports